export const VARIABLES_CONFIGS = {
  ADD: 'add',
  DELETE: 'delete',
  SUCCESS: 'success'
}


export const ACTION_TYPE = {
  GET_WATCHLIST: 'GET_WATCHLIST'
}

export const WINVEST_PARAMS_JSON_FLAG = {
  KEY: '@_@WINVEST_JSON_FLAG_KEY',
  VALUE: '@_@WINVEST_JSON_FLAG_VALUE'
}

export const WINVEST_PARAMS_REMOVE_TOKEN = {
  KEY: '@_@WINVEST_PARAMS_REMOVE_TOKEN_KEY',
  VALUE: '@_@WINVEST_PARAMS_REMOVE_TOKEN_VALUE'
}

export const WINVEST_PARAMS_REMOVE_UUID = {
  KEY: '@_@WINVEST_PARAMS_REMOVE_UUID_KEY',
  VALUE: '@_@WINVEST_PARAMS_REMOVE_UUID_VALUE'
}